import helpers from '../../util/helpers';

const searchOfferTypes = () => {
  jQuery(document).ready(function($) {
    const page = $('html, body');

    // Offer types Autocomplete
    const offerTypesSearch = $('input.offers-search');
    if (offerTypesSearch.length) {
      offerTypesSearch.each(function() {
        const _this = $(this);

        _this.rsdAutocomplete({
          minimumInputLength: -1,
          maxResults: -1,
          data: _this.data('feed') ? _this.data('feed') : [],
          layout: 1,
          showListName: false,
        });
      });

      offerTypesSearch.on('click', function() {
        if (helpers.isMobile()) {
          page.on('scroll mousewheel touchmove', function() {
            page.stop();
          });

          page.animate({scrollTop: $(this).offset().top}, 'slow', function() {
            page.off('scroll mousewheel touchmove');
          });
        }
      });

      offerTypesSearch.on('input', function() {
        const _this = $(this);

        if (_this.data('cookie-offer-type') && _this.val().length === 0) {
          helpers.docCookies.setItem(_this.data('cookie-offer-type'), _this.val(), 1500, '/');
        }
      }).on('input_changed.rsd-ac', function() {
        const _this = $(this);

        if (_this.data('cookie-offer-type')) {
          helpers.docCookies.setItem(_this.data('cookie-offer-type'), _this.val(), 1500, '/');
        }
      });
    }
  });
};

export default searchOfferTypes;



// WEBPACK FOOTER //
// ./scripts/routes/modules/searchOfferTypes.js